// `Preferences.storageKey` appends the org and blob segments independently, but `getAll` reads back only the
// `{}`, `{orgId}` and `{orgId, blobId}` levels — a blob with no org writes a key no read ever visits, and an org
// with no blob writes an org-wide override for a per-blob key. A partial scope is therefore treated as none.
export function hasFullScope(scope) {
  return !!(scope && scope.orgId && scope.blobId);
}
